import React, { useState } from "react";
import { AppModal, ModalHeader, ModalBody, ModalFooter, Button } from "../../components/Common/AppOverlay";
import { postRawData } from "../../helpers/url-request";

export default function EditProfile({ profile, close, saved }) {
  const [fullName, setFullName] = useState(profile.fullName || profile.name || "");
  const [mobileNo, setMobileNo] = useState(profile.mobileNo || profile.mobileNumber || profile.phoneNumber || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const dismiss = () => { if (!busy) close(); };
  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    const name = fullName.trim();
    const contact = mobileNo.trim();
    if (!name || name.length > 200) {
      setError("Enter a full name of up to 200 characters."); return;
    }
    if (!/^[+0-9() .\-]{3,30}$/.test(contact) || (contact.match(/\d/g) || []).length < 3) {
      setError("Enter a valid contact number of up to 30 characters."); return;
    }
    setBusy(true);
    setError("");
    try {
      const data = new FormData();
      data.append("UserId", profile.userId || profile.id);
      data.append("FullName", name);
      data.append("MobileNo", contact);
      const response = await postRawData("/user/updateprofile", "POST", data);
      if (!response?.status) throw new Error(response?.message || "Unable to save your profile. Please try again.");
      saved({ fullName: name, mobileNo: contact });
    } catch (err) {
      setError(err.message || "Unable to save your profile. Please try again.");
    } finally { setBusy(false); }
  };
  return (
    <AppModal isOpen toggle={dismiss} labelledBy="edit-profile-title">
      <ModalHeader id="edit-profile-title" toggle={busy ? undefined : dismiss}>Edit Profile</ModalHeader>
      <form onSubmit={submit}>
        <ModalBody>
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
          <div className="mb-3">
            <label htmlFor="profile-full-name" className="form-label">Full Name *</label>
            <input id="profile-full-name" className="form-control" autoComplete="name" required maxLength={200} value={fullName} disabled={busy} onChange={(e) => setFullName(e.target.value)} />
          </div>
          <div className="mb-3">
            <label htmlFor="profile-contact" className="form-label">Contact Number *</label>
            <input id="profile-contact" className="form-control" type="tel" autoComplete="tel" required maxLength={30} value={mobileNo} disabled={busy} onChange={(e) => setMobileNo(e.target.value)} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={dismiss} disabled={busy}>Cancel</Button>
          <Button type="submit" color="primary" disabled={busy}>{busy ? "Saving…" : "Save changes"}</Button>
        </ModalFooter>
      </form>
    </AppModal>
  );
}
